module.exports = __webpack_public_path__ + "static/media/school.da37310a.png";